import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { LOG_LEVELS } from "../../utils/logger";
import Logger from "../../utils/logger";
import BulkOperationStatusDetails from './BulkOperationStatusDetails';

const log = new Logger('BULK_OPERATION_STATUS_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES = {
  modal: "custom-modal-class",
  overlay: "custom-overlay-class",
};

class BulkOperationStatusModal extends React.Component {
  render() {
    log.debug('render(): BulkOperationStatusModal: props: ', this.props);

    return (
      <span>
        <Modal
          classNames={MODAL_CLASSNAMES}
          open={this.props.showModal}
          onClose={this.props.onCloseModal}
          closeOnEsc={true}
          blockScroll={true}
          closeOnOverlayClick={true}
          center
        >
          <h2><LanguageStringResolver string='Title_ProcessedDocuments_FailedEntities' /></h2>
          <BulkOperationStatusDetails operations={this.props.operations} />
        </Modal>
      </span>
    );
  };
}


BulkOperationStatusModal.defaultProps = {
  showModal: false,
  onCloseModal: () => { },
  operations: []
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(BulkOperationStatusModal);